/*
 * 4AM feedback / exit survey (snippets/t4m-collection-feedback.liquid).
 *
 * Opens from the "Não encontrou o que procurava?" block, or on its own only on an
 * exit signal: the mouse leaving through the top of the window (desktop) or a fast
 * scroll back to the top (mobile, where browsers expose no exit event). The automatic
 * opening happens once per browser, ever; the block can always open it.
 *
 * Each answer is pushed to window.dataLayer (event "exit_survey") and, when the
 * dialog has data-endpoint, POSTed there as JSON (schema "t4m.feedback.v1").
 * The dialog lives inside the product grid, which facets.js re-renders, so it is
 * looked up again whenever the old node is gone.
 */
(function () {
  'use strict';

  if (window.__t4mSurveyBound) return;
  window.__t4mSurveyBound = true;

  var SCHEMA = 't4m.feedback.v1';
  var AUTO_SHOWN_KEY = 't4m-survey:auto-shown';
  var SESSION_ID = 't4m-survey:sid';
  var DONE_KEY = 't4m-survey:done';
  var LEAD_CAPTURED_KEY = 't4amLeadCapture:captured';
  var MAX_COMMENT = 280;
  var MOBILE_MAX = 719;
  var T0 = Date.now();

  var store = {
    get: function (area, key) {
      try { return window[area].getItem(key); } catch (e) { return null; }
    },
    set: function (area, key, value) {
      try { window[area].setItem(key, value); } catch (e) { /* storage blocked: survey still works */ }
    }
  };

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function sessionId() {
    var id = store.get('sessionStorage', SESSION_ID);
    if (!id) {
      id = uuid();
      store.set('sessionStorage', SESSION_ID, id);
    }
    return id;
  }

  function track(event, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event };
    Object.keys(params || {}).forEach(function (k) { payload[k] = params[k]; });
    window.dataLayer.push(payload);
  }

  /* ---------- cart snapshot (count + total), refreshed after cart changes ---------- */
  var cart = {
    item_count: 0,
    total_cents: 0,
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL'
  };
  function refreshCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        cart = { item_count: data.item_count || 0, total_cents: data.total_price || 0, currency: data.currency || cart.currency };
      })
      .catch(function () { /* keep the last snapshot */ });
  }
  refreshCart();
  document.addEventListener('cartUpdated', refreshCart);

  /* ---------- dialog ---------- */
  var dialog = null;
  var el = null;
  var state = { reason: null, reasonLabel: '', detail: '', trigger: '' };

  function ensureDialog() {
    if (dialog && dialog.isConnected) return true;
    var found = document.getElementById('T4mSurvey');
    if (!found || typeof found.showModal !== 'function') return false;
    dialog = found;
    var q = function (sel) { return dialog.querySelector(sel); };
    el = {
      kicker: q('[data-t4m-kicker]'),
      title: q('[data-t4m-title]'),
      steps: dialog.querySelectorAll('[data-t4m-step]'),
      form: q('form[data-t4m-step="2"]'),
      picked: q('[data-t4m-picked]'),
      question: q('[data-t4m-question]'),
      chips: q('[data-t4m-chips]'),
      comment: q('[data-t4m-comment]'),
      thanksTitle: q('[data-t4m-thanks-title]'),
      thanks: q('[data-t4m-thanks]'),
      acts: q('[data-t4m-acts]')
    };
    bindDialog();

    return true;
  }

  function showStep(n) {
    Array.prototype.forEach.call(el.steps, function (s) { s.hidden = s.getAttribute('data-t4m-step') !== String(n); });
    var kickers = { 1: 'kickerStart', 2: 'kickerDetail', 3: 'kickerDone' };
    el.kicker.textContent = dialog.dataset[kickers[n]] || '';
  }

  function reset() {
    state = { reason: null, reasonLabel: '', detail: '', trigger: state.trigger };
    el.comment.value = '';
    showStep(1);
  }

  function otherOverlayOpen() {
    if (document.querySelector('dialog[open]:not(#T4mSurvey)')) return true;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) return true;
    return document.body.classList.contains('overflow-hidden');
  }

  function canAutoShow() {
    return dialog.dataset.exitTriggers === 'true'
      && !store.get('localStorage', AUTO_SHOWN_KEY)
      && !store.get('localStorage', DONE_KEY)
      && !dialog.open
      && !otherOverlayOpen();
  }

  function open(trigger, force) {
    if (!ensureDialog() || dialog.open) return;
    if (!force && !canAutoShow()) return;
    if (!force) store.set('localStorage', AUTO_SHOWN_KEY, String(Date.now()));
    state.trigger = trigger;
    reset();
    el.title.textContent = cart.item_count > 0 ? dialog.dataset.titleCart : dialog.dataset.titleBrowse;
    dialog.showModal();
    document.body.classList.add('t4m-ex-on');
    track('exit_survey_view', { trigger: trigger, cart_items: cart.item_count, cart_value: cart.total_cents / 100 });
  }

  function close() {
    if (dialog && dialog.open) dialog.close();
  }

  function dismiss() {
    if (dialog.open && el.steps[2].hidden) track('exit_survey_dismiss', { trigger: state.trigger });
    close();
  }

  function pickReason(button) {
    state.reason = button.getAttribute('data-reason');
    state.reasonLabel = button.textContent.trim();
    state.detail = '';
    el.picked.textContent = state.reasonLabel;
    el.question.textContent = button.getAttribute('data-question') || '';
    el.chips.replaceChildren();
    var chips = (button.getAttribute('data-chips') || '').split('|')
      .map(function (c) { return c.trim(); })
      .filter(function (c) { return c && c.indexOf('translation missing') === -1; });
    chips.forEach(function (label) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 't4m-ex__chip';
      chip.setAttribute('aria-pressed', 'false');
      chip.textContent = label;
      el.chips.appendChild(chip);
    });
    el.comment.placeholder = chips.length ? dialog.dataset.placeholderMore : dialog.dataset.placeholderFree;
    showStep(2);
    var first = el.chips.querySelector('.t4m-ex__chip');
    if (first) first.focus({ preventScroll: true });
    else if (window.innerWidth > MOBILE_MAX) el.comment.focus({ preventScroll: true });
  }

  /* ---------- payload (t4m.feedback.v1) ----------
     The backend validates strictly (unknown field = 400), so every value is clamped to
     its contract here. Who the customer is comes only from Shopify's App Proxy, so the
     payload carries no customer data. */
  var LIMITS = { label: 80, detail: 80, comment: 280, short: 40, lang: 35, sort: 64, handle: 255, path: 512, filterKeys: 20, filterValues: 10, filterChars: 100 };

  function clean(value, max) {
    if (value === null || value === undefined) return null;
    return String(value).replace(/\u0000/g, '').slice(0, max);
  }

  function clampInt(value, min, max) {
    var n = Math.round(Number(value));
    if (!isFinite(n)) return null;
    return Math.min(max, Math.max(min, n));
  }

  function referrerHost() {
    if (!document.referrer) return null;
    try { return new URL(document.referrer).hostname || null; } catch (e) { return null; }
  }

  function activeFilters(params) {
    var filters = {};
    var keys = 0;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') !== 0) return;
      var k = clean(key, LIMITS.filterChars);
      if (!filters[k]) {
        if (keys >= LIMITS.filterKeys) return;
        filters[k] = [];
        keys++;
      }
      if (filters[k].length < LIMITS.filterValues) filters[k].push(clean(value, LIMITS.filterChars));
    });
    return filters;
  }

  function buildPayload(comment) {
    var params = new URLSearchParams(window.location.search);
    var path = window.location.pathname.replace(/^\/+/, '/');
    var currency = String(cart.currency || '').toUpperCase();
    return {
      schema: SCHEMA,
      event_id: uuid(),
      type: 'exit_survey',
      submitted_at: new Date().toISOString(),
      trigger: state.trigger,
      answer: {
        reason: state.reason,
        reason_label: clean(state.reasonLabel, LIMITS.label),
        detail: clean(state.detail, LIMITS.detail) || '',
        comment: clean(comment, LIMITS.comment) || ''
      },
      context: {
        shop: dialog.dataset.shop,
        theme_id: clampInt(dialog.dataset.themeId, 0, Number.MAX_SAFE_INTEGER),
        page_type: clean(dialog.dataset.pageType, LIMITS.short),
        path: clean(path, LIMITS.path),
        collection_handle: clean(dialog.dataset.collectionHandle || null, LIMITS.handle),
        collection_title: clean(dialog.dataset.collectionTitle || null, LIMITS.handle),
        sort_by: clean(params.get('sort_by'), LIMITS.sort),
        filters: activeFilters(params),
        seconds_on_page: clampInt((Date.now() - T0) / 1000, 0, 86400),
        device: window.innerWidth > MOBILE_MAX ? 'desktop' : 'mobile',
        viewport_width: clampInt(window.innerWidth, 0, 10000),
        language: clean(document.documentElement.lang || navigator.language || null, LIMITS.lang),
        referrer_host: referrerHost()
      },
      cart: /^[A-Z]{3}$/.test(currency)
        ? { item_count: clampInt(cart.item_count, 0, 10000), total_cents: clampInt(cart.total_cents, 0, Number.MAX_SAFE_INTEGER), currency: currency }
        : null,
      session_id: sessionId()
    };
  }

  /* Sent to the Shopify App Proxy on the store's own domain ("/apps/<subpath>/feedback").
     Same origin: the login cookie must go along so Shopify forwards the signed
     logged_in_customer_id. keepalive lets the request finish if the shopper leaves. */
  var APP_PROXY_PATH = /^\/apps\/[A-Za-z0-9_\-]+(\/[A-Za-z0-9_\-]+)*$/;

  function send(payload) {
    var endpoint = (dialog.dataset.endpoint || '').trim();
    if (!APP_PROXY_PATH.test(endpoint)) return Promise.resolve(null);
    return fetch(endpoint, {
      method: 'POST',
      keepalive: true,
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  function submit(event) {
    event.preventDefault();
    if (!state.reason) return;
    var comment = el.comment.value.trim().slice(0, MAX_COMMENT);
    var payload = buildPayload(comment);
    // No free text and no customer data in the dataLayer: every tag (GA4, Meta...) can read it.
    track('exit_survey', {
      reason: payload.answer.reason,
      detail: payload.answer.detail,
      has_comment: comment.length > 0,
      comment_length: comment.length,
      trigger: payload.trigger,
      cart_items: cart.item_count,
      cart_value: cart.total_cents / 100,
      feedback_id: payload.event_id
    });
    send(payload).then(function (ok) {
      if (ok === false) console.warn('[t4m-survey] endpoint did not accept answer', payload.event_id);
    });
    store.set('localStorage', DONE_KEY, String(Date.now()));
    thanks();
  }

  function actionButton(label, go, primary) {
    var isLink = go === 'whatsapp';
    var b = document.createElement(isLink ? 'a' : 'button');
    if (isLink) {
      b.href = dialog.dataset.whatsappUrl;
      b.target = '_blank';
      b.rel = 'noopener';
    } else {
      b.type = 'button';
    }
    b.className = primary ? 't4m-ex__cta' : 't4m-ex__ghost';
    b.setAttribute('data-go', go);
    b.textContent = label;
    return b;
  }

  function thanks() {
    var d = dialog.dataset;
    var msg = d.thanksDefault;
    var acts = [];
    var hasWhatsapp = /^https:\/\//i.test(d.whatsappUrl || '');
    var canOfferCoupon = document.querySelector('[data-lcp-open]') && !store.get('localStorage', LEAD_CAPTURED_KEY);
    if ((state.reason === 'tamanho_indisponivel' || state.reason === 'duvida_tamanho') && hasWhatsapp) {
      msg = d.thanksSize;
      acts.push(actionButton(d.actionConsultant, 'whatsapp', true));
    } else if ((state.reason === 'pagamento' || state.reason === 'erro_site') && hasWhatsapp) {
      msg = d.thanksCheckout;
      acts.push(actionButton(d.actionBuyConsultant, 'whatsapp', true));
    } else if ((state.reason === 'preco' || state.reason === 'frete_prazo') && canOfferCoupon) {
      msg = d.thanksCoupon;
      acts.push(actionButton(d.actionCoupon, 'coupon', true));
    }
    acts.push(actionButton(d.actionClose, 'close', false));
    el.thanks.textContent = msg;
    el.acts.replaceChildren.apply(el.acts, acts);
    showStep(3);
    el.thanksTitle.focus({ preventScroll: true });
  }

  function onDialogClick(e) {
    if (e.target === dialog) return dismiss(); // backdrop
    var t = e.target;
    if (t.closest('[data-t4m-dismiss]')) return dismiss();
    if (t.closest('[data-t4m-back]')) return reset();
    var op = t.closest('.t4m-ex__op');
    if (op) return pickReason(op);
    var chip = t.closest('.t4m-ex__chip');
    if (chip) {
      var on = chip.getAttribute('aria-pressed') !== 'true';
      el.chips.querySelectorAll('.t4m-ex__chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', String(on));
      state.detail = on ? chip.textContent : '';
      return;
    }
    var go = t.closest('[data-go]');
    if (!go) return;
    var action = go.getAttribute('data-go');
    close();
    if (action === 'coupon') {
      var leadTab = document.querySelector('[data-lcp-open]');
      if (leadTab) leadTab.click();
    }
  }

  function bindDialog() {
    dialog.addEventListener('click', onDialogClick);
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      dismiss();
    });
    dialog.addEventListener('close', function () { document.body.classList.remove('t4m-ex-on'); });
    el.form.addEventListener('submit', submit);
  }

  /* ---------- automatic opening: exit signals only ---------- */
  var MIN_ON_PAGE_MS = 15000;

  function bindTriggers() {
    if (dialog.dataset.exitTriggers !== 'true') return;

    // desktop: the mouse leaves through the top of the window (towards tabs / address bar)
    document.addEventListener('mouseout', function (e) {
      if (window.innerWidth <= MOBILE_MAX || e.relatedTarget || e.clientY > 8 || Date.now() - T0 < MIN_ON_PAGE_MS) return;
      open('mouse_saindo');
    });

    // mobile: no exit event exists, so a fast flick back to the top (reaching for the
    // address bar / back button) is used as the exit signal
    var lastY = window.scrollY, lastT = Date.now(), acc = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY, t = Date.now(), dy = lastY - y, dt = t - lastT;
      lastY = y;
      lastT = t;
      if (window.innerWidth > MOBILE_MAX || Date.now() - T0 < MIN_ON_PAGE_MS) return;
      acc = dy > 0 && dt < 250 ? acc + dy : 0;
      if (acc > 900 && y < 300) {
        acc = 0;
        open('rolou_topo');
      }
    }, { passive: true });
  }

  /* ---------- block shortcuts: open straight on the chosen reason ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-t4m-survey-open]');
    if (!b || !ensureDialog()) return;
    var reasonId = (b.getAttribute('data-t4m-survey-open') || '').replace(/[^a-z_]/g, '');
    open('bloco_fim_lista', true);
    var op = dialog.querySelector('.t4m-ex__op[data-reason="' + reasonId + '"]');
    if (op) pickReason(op);
  });

  function start() {
    if (!ensureDialog()) return;
    bindTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
